export default __webpack_public_path__ + "static/media/Vows of the Empire.81edfb93.jpg";